/** Percorso inesistente. */

import { Link } from "react-router-dom";
import { IntestazionePagina } from "../layout/Guscio";
import { StatoVuoto } from "../components/primitive";

export function NonTrovata() {
  return (
    <div className="pila">
      <IntestazionePagina sopratitolo="404" titolo="Pagina non trovata" />
      <section className="scheda">
        <StatoVuoto
          titolo="Questo indirizzo non corrisponde ad alcuna sezione"
          testo="Puo' essere un collegamento non piu' valido oppure una sezione riservata a un altro ruolo."
          azione={
            <Link className="bottone bottone--primario" to="/">
              Torna al cruscotto
            </Link>
          }
        />
      </section>
    </div>
  );
}
